import { render } from "./EditAppeal.vue?vue&type=template&id=00033aa2"
import script from "./EditAppeal.vue?vue&type=script&setup=true&lang=js"
export * from "./EditAppeal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/DirectMail/EditAppeal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "00033aa2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('00033aa2', __exports__)) {
    api.reload('00033aa2', __exports__)
  }
  
  module.hot.accept("./EditAppeal.vue?vue&type=template&id=00033aa2", () => {
    api.rerender('00033aa2', render)
  })

}


export default __exports__